import type {
  IAddEventUserToWatchlistRequestParams,
  IAddEventUserToWatchlistResponseBody,
  IDeleteEventFromUserToWatchlistRequestParams,
  IDeleteEventUserFromWatchlistResponseBody,
  IGetUserWatchlistResponseBody,
  ISyncUserWatchlistRequestBody,
  ISyncUserWatchlistResponseBody,
} from "~/feature/watchlist/types";
import { api, ApiTagType } from "~/store/api";

const watchlistApi = api.injectEndpoints({
  endpoints: (builder) => ({
    syncUserWatchlist: builder.mutation<
      ISyncUserWatchlistResponseBody,
      ISyncUserWatchlistRequestBody
    >({
      query: (body) => ({
        url: "user/watchlist/sync",
        method: "POST",
        body,
      }),
      invalidatesTags: [ApiTagType.Watchlist],
    }),
    getUserWatchlist: builder.query<IGetUserWatchlistResponseBody, void>({
      query: () => ({
        url: "user/watchlist",
      }),
      providesTags: [ApiTagType.Watchlist],
    }),
    addEventToUserWatchlist: builder.mutation<
      IAddEventUserToWatchlistResponseBody,
      IAddEventUserToWatchlistRequestParams
    >({
      query: ({ id }) => ({
        url: `user/watchlist/${id}`,
        method: "POST",
      }),
      invalidatesTags: [ApiTagType.Watchlist],
    }),
    deleteEventFromUserWatchlist: builder.mutation<
      IDeleteEventUserFromWatchlistResponseBody,
      IDeleteEventFromUserToWatchlistRequestParams
    >({
      query: ({ id }) => ({
        url: `user/watchlist/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [ApiTagType.Watchlist],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserWatchlistQuery,
  useSyncUserWatchlistMutation,
  useAddEventToUserWatchlistMutation,
  useDeleteEventFromUserWatchlistMutation,
} = watchlistApi;
